import get from 'lodash.get';
import isEmpty from 'lodash.isempty';

import {
  ASSET_ERC20,
  ASSET_DEFI,
  ASSET_EXCHANGE,
  ASSET_STABLECOIN,
  ASSET_TOKENIZED,
  ASSET_TOP,
  DEFAULT_ASSETS_ORDER,
} from '../../constants/app';

import { createDeepEqualSelector } from '../utils/selectors';

const selectEndpoints = (state) => state.endpoints;

const filterAssets = (tag) => (assets = []) => assets.filter(({ tags = [] }) => tags.includes(tag));

export const selectEndpointsData = createDeepEqualSelector(selectEndpoints, (endpoints) => get(endpoints, 'data', {}));

export const selectIsLoading = createDeepEqualSelector(selectEndpoints, (endpoints) => endpoints.loading);

export const selectErr = createDeepEqualSelector(selectEndpoints, (endpoints) => endpoints.err);

export const selectErrMsg = createDeepEqualSelector(selectEndpoints, (endpoints) => endpoints.errMsg);

export const selectAssets = createDeepEqualSelector(selectEndpoints, (endpoints) => get(endpoints, 'assets', []));

export const selectTopAssets = createDeepEqualSelector(selectAssets, (assets = []) => {
  const topAssets = assets.filter(({ tags = [] }) => tags.includes(ASSET_TOP));
  const head = topAssets.filter((item) => DEFAULT_ASSETS_ORDER.includes(item.symbol));
  const tail = topAssets.filter((item) => !DEFAULT_ASSETS_ORDER.includes(item.symbol));

  const headSorted = DEFAULT_ASSETS_ORDER.reduce((acc, c) => {
    const value = head.find((item) => item.symbol === c);
    if (value) {
      acc.push(value);
    }

    return acc;
  }, []);

  return [...headSorted, ...tail];
});

export const selectStablecoinAssets = createDeepEqualSelector(selectAssets, filterAssets(ASSET_STABLECOIN));

export const selectExchangeAssets = createDeepEqualSelector(selectAssets, filterAssets(ASSET_EXCHANGE));

export const selectDefiAssets = createDeepEqualSelector(selectAssets, filterAssets(ASSET_DEFI));

export const selectTokenizedAssets = createDeepEqualSelector(selectAssets, filterAssets(ASSET_TOKENIZED));

export const selectErc20Assets = createDeepEqualSelector(selectAssets, (assets = []) =>
  assets.filter(
    ({ tags = [] }) =>
      tags.includes(ASSET_ERC20) &&
      !(
        tags.includes(ASSET_STABLECOIN) ||
        tags.includes(ASSET_EXCHANGE) ||
        tags.includes(ASSET_DEFI) ||
        tags.includes(ASSET_TOKENIZED)
      ),
  ),
);

export const selectIsEndpointsDataEmpty = createDeepEqualSelector(selectEndpointsData, (data) => isEmpty(data));
